import React from 'react';
import { Badge } from './badge';
import { BadgeType } from './badge.styles';

export interface IPriorAuthBadgeProps {
    className?: string;
    label: string;
    number: string;
}

export const PriorAuthBadge: React.FunctionComponent<IPriorAuthBadgeProps> = ({ className, label, number }) => (
    <Badge className={className} type={BadgeType.BLUE_LIGHT} size="small" title={`${label}: ${number}`}>
        {label}: {number}
    </Badge>
);
